module.exports = __webpack_public_path__ + "static/img/polling_null@2x.f0547453.png";